import React, { createContext, useContext, useState, useCallback } from 'react';

import { ReactFCC } from '@types';

import { initalState } from './initial';
import { ErrorMap, IValidationContextType } from './model';

const ValidationContext = createContext<IValidationContextType>(initalState);

export const ValidationContextProvider: ReactFCC = ({ children }) => {
  const [errors, setErrors] = useState<ErrorMap>({});
  const [lastErrorField, setLastErrorField] = useState<string | null>(null);

  const reportError = useCallback((field: string, message: string) => {
    setErrors((prev) => ({ ...prev, [field]: message }));
    setLastErrorField(field);
  }, []);

  const clearError = useCallback((field: string) => {
    setErrors((prev) => {
      const { [field]: _, ...rest } = prev;
      return rest;
    });
  }, []);

  const getAllErrors = () => Object.values(errors);
  const getAllErrorsWithFields = () => Object.entries(errors).map(([field, message]) => ({ field, message }));
  const getLatestError = () => {
    if (lastErrorField && errors[lastErrorField]) {
      return { field: lastErrorField, message: errors[lastErrorField] };
    }
    return null;
  };

  const getErrorByField = (field: string) => {
    const error = errors[field];
    if (error) {
      return { field: field, message: errors[error] };
    }
    return null;
  };

  return (
    <ValidationContext.Provider
      value={{
        errors,
        reportError,
        clearError,
        getAllErrors,
        getAllErrorsWithFields,
        getLatestError,
        getErrorByField,
      }}>
      {children}
    </ValidationContext.Provider>
  );
};

export const useValidationContext = () => useContext(ValidationContext);
